import { Component, Input, OnChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import { HighchartsChartModule } from 'highcharts-angular';
import { ILuminaria } from 'modelos/src';
import { LuminariasHttpService } from '../../../../../auxiliares/servicios/http/luminarias.service';

@Component({
  selector: 'app-pie-chart-modelos',
  templateUrl: './pie-chart-modelos.component.html',
  styleUrl: './pie-chart-modelos.component.scss',
  imports: [HighchartsChartModule],
})
export class PieChartLuminariasModelosComponent implements OnChanges {
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};
  chartInstance?: Highcharts.Chart;

  @Input() title = '';
  @Input() subtitle = '';
  @Input() data: ILuminaria[] = [];
  @Input() chartStyle = 'width: 100%; height: 320px; display: block';

  public seriesData: {
    name: string;
    y: number;
    color?: string;
  }[] = [];

  saveInstance(chart: Highcharts.Chart) {
    this.chartInstance = chart;
  }

  ngOnChanges(): void {
    if (this.chartInstance) {
      this.chartInstance.drillUp();
    }

    const total = this.data.length;

    // Conteo de luminarias por modelo (marca + modelo)
    const conteoModelos: { [modelo: string]: number } = {};
    this.data.forEach((luminaria) => {
      const marca = luminaria.modeloDispositivo?.marca ?? 'Sin marca';
      const modelo = luminaria.modeloDispositivo?.modelo ?? 'Sin modelo';
      const nombreModelo = `${marca} ${modelo}`;

      if (!conteoModelos[nombreModelo]) {
        conteoModelos[nombreModelo] = 0;
      }
      conteoModelos[nombreModelo] += 1;
    });

    // Convertir a datos para la serie
    this.seriesData = Object.entries(conteoModelos).map(
      ([modelo, cantidad]) => ({
        name: modelo,
        y: total > 0 ? +((cantidad / total) * 100).toFixed(1) : 0,
      }),
    );

    // Opciones del gráfico
    const chartOptions: Highcharts.Options = {
      chart: {
        type: 'pie',
        backgroundColor: 'var(--bg-grafico)',
        style: {
          color: 'var(--fg-grafico)',
        },
      },
      title: { text: this.title, style: { color: 'var(--fg-grafico)' } },
      subtitle: { text: this.subtitle },
      accessibility: {
        announceNewData: { enabled: true },
        point: { valueSuffix: '%' },
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: false,
            format: '{point.name}: {point.y:.1f}%',
          },
          showInLegend: true,
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:
          '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> del total<br/>',
      },
      legend: {
        enabled: true,
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
        itemStyle: {
          color: 'var(--p-text-color)',
        },
      },
      exporting: {
        enabled: false,
      },
      series: [
        {
          name: 'Modelos',
          colorByPoint: true,
          type: 'pie',
          data: this.seriesData,
        } as Highcharts.SeriesPieOptions,
      ],
    };

    this.chartOptions = chartOptions;
  }
}
